module.exports = __webpack_public_path__ + "img/gPay-Payment-Active.e267ce81.svg";